import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { Department } from '../../types';
import { DepartmentsForm } from './form/DepartmentsForm';

export const DepartmentsManager = ({ list }: { list: Department[] }) => {
  return (
    <CardContainer title="Departments">
      <DepartmentsForm list={list} />
    </CardContainer>
  );
};
